/* 
 *  Created by SGiri 02/14/2018
 */

import { BrowserModule, } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppComponent } from "./app.component";
import { HttpModule, JsonpModule } from '@angular/http';
import { AppUtil } from "./util/app.util";
import { NavbarComponent } from './navbar/navbar.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { BI_HttpInterceptor } from "./util/bihttp-interceptor";
import { CommonService } from "./util/common.service";
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { AuthModule, provideAuth } from "~auth/auth.module";
import { AoCookieProvider, DacTokenProvider } from "~auth/providers";
import { CoreModule } from "~core/core.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "~environment";
import { ReportingConfigModule } from "~config/config.module";
import { AdmingModule } from "~admin/bi-admin.module";
import { BI_HttpService } from "./services/http.service";
import { CognosModule } from "~cognos/cognos.module";
import { LeftNavComponent } from "./navbar/left-nav/left-nav.component";

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        LeftNavComponent,
        InfoDialogComponent,
    ],
    imports: [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        JsonpModule,
        AuthModule.forRoot([
            provideAuth(AoCookieProvider),
            provideAuth(DacTokenProvider)
        ], {
                redirectUrl: '/',
                token: environment.authTokenName,
                cookie: environment.authCookieName,
                aoUrl: environment.assetOptimizationURL,
                baseUrl: environment.baseUrl,
                paymentGatewayUrl: environment.paymentGatewayUrl,
                useCookie: environment.useCookie,
                interceptor: BI_HttpInterceptor
            }),
        CoreModule.forRoot(),

        ReportingConfigModule,
        AdmingModule,
        CognosModule,
        NgbModule.forRoot(),

    ],
    providers: [
        AppUtil,
        CommonService,
        BI_HttpService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BI_HttpInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/app.module.ts